export default __webpack_public_path__ + "static/media/near.9e7a14a9.png";